<template>
  <div>
    <div class="fullpage-container" @wheel="handleWheel">
      <div 
        class="fullpage-wrapper" 
        :style="{ transform: `translateY(-${currentIndex * 100}vh)` }"
      >
        <!-- 第一屏 -->
        <section class="fullpage-section section-1" >
          <div class="section-content_1">
            <img class="topBT" src="@/assets/img/home/top_b_other.png" alt="">
            <img class="topBigCenter" 
              src="@/assets/img/home/carbonneBigCenter.png" 
              alt=""
            >
            <div class="topSmallCenter">
              <div class="topSmallCenter_title">碳芯 丨 双碳领域垂直专业大模型</div>
              <div class="topSmallCenter_desc">8万+条人工标注高精度双碳QA、10万+条各地政策法规、15万+条全<br>球排放因子库（Scope 1/2/3全覆盖）</div>
            </div>
            <div class="section-1_bottom">
              <img class="section-1_bottom_img" src="@/assets/img/home/section-1_bottom_img.png">
              <img class="section-1_bottom_img" src="@/assets/img/home/section-1_bottom_img_other.png">
              <!-- <div class="section-1_bottom_desc">生成式人工智能服务备案登记号：ShangHai ZhongTan Pu Hui YunAIFuWu-20241118 S0046</div> -->
            </div>
          </div>
        </section>
        
        <!-- 第三屏 -->
        <section class="fullpage-section section-3">
          <div class="section-3-container" :class="{ 'scrollable': currentIndex === 2 }">
            <div class="section-3-content">
              <!-- <div class="section-3-content_1" @click="gotoWeb">
                <img class="section-3-content_1_img" src="@/assets/img/home/section-3-content_1_img.png" alt="">
              </div> -->
              <div class="section-3-content_2">
                <div class="section-3-content_2_t">
                  <img class="section-3-content_2_t_img" src="@/assets/img/home/section-3-content_2_t_img.png" alt="">
                </div>
                <div class="section-3-content_2_b">
                  <img class="section-3-content_2_b_img" src="@/assets/img/home/section-3-content_2_b_img.png" alt="">
                </div>
              </div>
              <div class="section-3-content_3">
                <img class="section-3-content_3_img" src="@/assets/img/home/section-3-content_3_img.png" alt="">
              </div>
            </div>
            <Footer pageType="production" />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Footer from '@/components/footer/index'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Footer
  },
  data() {
    return {
      currentIndex: 0, // 当前屏幕索引
      isScrolling: false, // 是否正在滚动中
      sections: 2, // 总屏幕数量
      transitionDuration: 1500, // 过渡动画时间（毫秒），这里改为1秒
      isSection3Scrolling: false, // 第三屏内部是否正在滚动
      section3ScrollPosition: 0, // 第三屏内部滚动位置
      isChatScrolling: false,
    };
  },
  mounted() {
    this.addTrackpadSupport();
    this.addContainerScrollListener();
    this.$emit('current-index-change', this.currentIndex);
    this.$emit('section-3-scroll-top-change', 0);
  },
  beforeDestroy() {
    this.removeTrackpadSupport();
    this.removeContainerScrollListener();
  },
  methods: {
    gotoWeb() {
      this.gotoWebSite()
    },
    /**
     * 添加容器滚动监听
     */
    addContainerScrollListener() {
      this.$nextTick(() => {
        const container = document.querySelector('.section-3-container');
        if (container) {
          this._section3ScrollHandler = () => {
            const scrollTop = container.scrollTop || 0;
            this.$emit('section-3-scroll-top-change', scrollTop);
          };
          container.addEventListener('scroll', this._section3ScrollHandler, { passive: true });
        }
      });
    },
    /**
     * 移除容器滚动监听
     */
    removeContainerScrollListener() {
      const container = document.querySelector('.section-3-container');
      if (container && this._section3ScrollHandler) {
        container.removeEventListener('scroll', this._section3ScrollHandler);
        this._section3ScrollHandler = null;
      }
    },
    /**
     * 添加触摸板支持
     */
    addTrackpadSupport() {
      // 监听触摸板手势
      document.addEventListener('wheel', this.handleWheel, { passive: false });
    },
    
    /**
     * 移除触摸板支持
     */
    removeTrackpadSupport() {
      document.removeEventListener('wheel', this.handleWheel);
    },
    /**
     * 处理鼠标滚轮和触摸板事件
     */
    handleWheel(e) {
      // 如果正在滚动中，则忽略后续滚轮事件
      if (this.isScrolling) return;

      // 如果聊天容器正在滚动，忽略全屏滚动
      if (this.isChatScrolling) return;

      // 如果在第三屏，优先处理内部滚动
      if (this.currentIndex === 1) {
        this.handleSection3Scroll(e);
        return;
      }

      // 对于非第三屏，阻止默认行为并处理全屏切换
      e.preventDefault();

      // 全屏切换逻辑
      if (e.deltaY > 0) {
        this.nextSection();
      } else {
        this.prevSection();
      }
    },

    /**
     * 处理第三屏内部滚动
     */
    handleSection3Scroll(e) {
      const section3Container = document.querySelector('.section-3-container');
      if (!section3Container) return;
      const container = section3Container;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;
      
      // 计算滚动方向
      const isScrollingDown = e.deltaY > 0;
      
      // 检查是否在边界（使用更大的容差）
      const isAtTop = scrollTop <= 10;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
      
      // 如果不在边界，允许自然滚动（不阻止默认行为）
      if ((isScrollingDown && !isAtBottom) || (!isScrollingDown && !isAtTop)) {
          // 不阻止默认行为，让浏览器处理自然滚动
        return;
      }
      
      // 如果在边界，阻止默认行为并处理全屏切换
      e.preventDefault();
      
      if ((isScrollingDown && isAtBottom) || (!isScrollingDown && isAtTop)) {
        if (isScrollingDown) {
          this.nextSection();
        } else {
          this.prevSection();
        }
      }
    },

    /**
     * 滚动到下一屏
     */
    nextSection() {
      if (this.currentIndex < this.sections - 1) {
        this.startScroll(this.currentIndex + 1);
      }
    },

    /**
     * 滚动到上一屏
     */
    prevSection() {
      if (this.currentIndex > 0) {
        this.startScroll(this.currentIndex - 1);
      }
    },

    /**
     * 开始滚动动画
     */
    startScroll(index) {
      this.isScrolling = true;
      this.currentIndex = index;
      this.$emit('current-index-change', this.currentIndex);
      
      // 滚动动画结束后重置状态
      setTimeout(() => {
          this.isScrolling = false;
      }, this.transitionDuration);
    },
  }
};
</script>

<style lang="scss" scoped>
.fullpage-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.fullpage-wrapper {
  width: 100%;
  height: 100%;
  transition: transform 1.5s ease-in-out;
  will-change: transform;
}

.fullpage-section {
  width: 100%;
  height: 100vh;
}

.section-content {
 position: relative;
 width: 100%;
 height: 100%;
}

.topBT{
  width: calc(100% * 1674 / 1920);
  height: calc(100% * 360 / 1080);
  position: absolute;
  top: calc(100% * 83 / 1080);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 4;
}

.topSmallCenter{
  width: calc(100% * 738 / 1920);
  position: absolute;
  top: calc(100% * 372 / 1080);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.topSmallCenter_desc{
  font-weight: 300;
  font-size: 18px;
  line-height: 150%;
  color: #FFFFFF;
  text-align: center;
  margin-top: 24px;
}

.topSmallCenter_title{
  font-weight: 400;
  font-size: 48px;
  line-height: 150%;
  color: #FFFFFF;
  text-shadow: 0px 1px 4px rgba(0, 0, 0, 1);
}

.topBigCenter{
  width: calc(100% * 1718 / 1920);
  max-height: calc(100vh - 120px);
  position: absolute;
  top: 80px;
  left: 100px;
  z-index: 3;
}

.section-1_bottom{
  height: 437px;
  left: 210px;
  bottom: 0;
  width: 1500px;
  position: absolute;
  z-index: 5;

  .section-1_bottom_img{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 6;
    top: 0;
    left: 0;
  }

  .section-1_bottom_desc{
    width: 100%;
    font-weight: 500;
    font-size: 20px;
    line-height: 150%;
    text-align: center;
    vertical-align: middle;
    position: absolute;
    bottom: 33px;
    color: rgba(255, 255, 255, 1);
    left: 50%;
    transform: translate(-50%);
  }
}

/* 各屏背景色 */
.section-1 {
  background: rgba(0, 0, 0, 1);
  position: relative;

  .section-content_1{
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
    width: 100%;
    height: 100%;
  }
}

.section-3 {
  height: 100vh;
  position: relative;
  overflow: hidden;

  .section-3-container {
    width: 100%;
    height: 100vh;
    transition: all 0.3s ease;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    min-height: 100vh;

    &.scrollable {
      overflow-y: auto!important;
      overflow-x: hidden;
      height: 100vh;
    }

    &::-webkit-scrollbar {
      display: none;
    }
     
    .section-3-content{
      width: 100%;
      background: rgba(0, 0, 0, 1);

      .section-3-content_1{
        width: 100%;
        height: 1000px;

        .section-3-content_1_img{
          width: 100%;
          height: 100%;
        }
      }

      .section-3-content_2{
        width: 100%;
        height: auto;
        overflow: hidden;
        // margin-top: 96px;
        background: linear-gradient(180deg, #000000 0%, #303030 25.63%, #404040 38.58%, #202020 45.11%, #000000 57.33%, #000000 100%);
      
        .section-3-content_2_t{
          width: 100%;
          height: 534px;
          margin-top: calc(100vh * 223 / 1080);

          .section-3-content_2_t_img{
            width: 100%;
            height: 100%;
          }
        }

        .section-3-content_2_b{
          width: 100%;
          height: 1323px;
          display: flex;
          justify-content: center;
          align-items: center;

          .section-3-content_2_b_img{
            width: 100%;
            height: 722px;
          }
        }
      }

      .section-3-content_3{
        width: 100%;
        height: 900px;
        display: flex;
        margin-top: -100px;
        justify-content: center;
        background: rgba(0, 0, 0, 1);

        .section-3-content_3_img{
          width: 1000px;
          height: 828px;
        }
      }
    }
  }
}
</style>